import { useState, type FormEvent } from "react"
import { Navigate, useLocation, useNavigate } from "react-router-dom"
import { ApiError, describeError } from "../api/http"
import { useAuth } from "../auth/AuthContext"
import { Note } from "../components/Note"

export default function LoginScreen() {
	const { session, login } = useAuth()
	const navigate = useNavigate()
	const location = useLocation() as { state?: { from?: string } }

	const [username, setUsername] = useState("")
	const [password, setPassword] = useState("")
	const [error, setError] = useState<string | null>(null)
	const [busy, setBusy] = useState(false)

	if (session) return <Navigate to={location.state?.from ?? "/groups"} replace />

	async function submit(event: FormEvent) {
		event.preventDefault()
		setError(null)
		setBusy(true)
		try {
			await login(username.trim(), password)
			navigate(location.state?.from ?? "/groups", { replace: true })
		} catch (cause) {
			setError(
				cause instanceof ApiError && cause.status === 403
					? "Логин или пароль неверны"
					: describeError(cause)
			)
		} finally {
			setBusy(false)
		}
	}

	return (
		<div className="login">
			<form className="login__card" onSubmit={submit}>
				<div className="login__brand">
					<span className="sidebar__flag" />
					Avtodelo&nbsp;Rīga
				</div>
				<div className="login__sub">Интерфейс рижской команды</div>

				{error && <Note tone="error">{error}</Note>}

				<div className="field">
					<label className="field__label" htmlFor="username">
						Логин
					</label>
					<input
						id="username"
						className="input input--lg"
						autoFocus
						autoComplete="username"
						value={username}
						onChange={event => setUsername(event.target.value)}
					/>
				</div>

				<div className="field">
					<label className="field__label" htmlFor="password">
						Пароль
					</label>
					<input
						id="password"
						type="password"
						className="input input--lg"
						autoComplete="current-password"
						value={password}
						onChange={event => setPassword(event.target.value)}
					/>
				</div>

				<button
					className="btn btn--primary btn--lg btn--block"
					disabled={busy || !username || !password}
				>
					{busy ? <span className="spinner" /> : "Войти"}
				</button>

				<div className="login__hint">
					Пароль хешируется в браузере (SHA-256) и уходит в сервис
					аутентификации — схема та же, что в основном интерфейсе.
				</div>
			</form>
		</div>
	)
}
